import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tab-cv',
  templateUrl: './tab-cv.component.html',
  styleUrls: ['./tab-cv.component.less']
})
export class TabCvComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
